import React, { useState, useEffect } from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
import { Uploader } from '../components/ecosystems';
import {getParameterByName, useWindowSize} from '../components/helpers';
import { gtag_report_conversion } from '../controller/api/gtagEvents';

const iframeOriginDomains = [
  'https://upload.afv.com',
  'http://uploader.afv.local:8086',
];

const UploadPage = props => {
  const [iframeSrc, setIframeSrc] = useState({});
  const iframeRef = React.useRef();
  const windowSize = useWindowSize();
  useEffect(() => {
    let url = 'https://upload.afv.com/';
    const utmSource = getParameterByName('utm_source', props.location.href);
    if (utmSource) {
      url = url + '?utm_source=' + utmSource;
    }
    setIframeSrc({ src: url });

    window.addEventListener('message', uploaderIframeMsgHandler);

    // clean up
    return () =>
      window.removeEventListener('message', uploaderIframeMsgHandler);
  }, []);

  const uploaderIframeMsgHandler = event => {
      if (
      event.data &&
      event.data.uploadEvent &&
      event.origin &&
      iframeOriginDomains.includes(event.origin)
    ) {
      fbq('trackCustom', event.data.uploadEvent);
      if (event.data.uploadEvent === 'Upload') {
        gtag_report_conversion();
        ttq.track('SubmitForm');
        twttr.conversion.trackPid('o6lpt', { tw_sale_amount: 0, tw_order_quantity: 0 });
        typeof window !== "undefined" && window.gtag("event", "click", {
          'event_category': 'upload',
          'event_label': 'form_submitted',
          'value': 1
        })
      }
      if (event.data.uploadEvent === 'CompleteSubmission') {
        twttr.conversion.trackPid('o6lpu', { tw_sale_amount: 0, tw_order_quantity: 0 });
        typeof window !== "undefined" && window.gtag("event", "click", {
          'event_category': 'upload',
          'event_label': 'submission_completed',
          'value': 1
        })
      }
        const iframePosition = iframeRef.current.offsetTop;
        window.scrollTo({
            behavior: "smooth",
            top: (windowSize.width <= 720 ? iframePosition : 0),
        });
    }
  };

  return (
    <Layout>
      <SEO title="Upload Video To Win Money - America's Funniest Home Videos" description=" " />
      <Uploader ref={iframeRef} {...iframeSrc} />
    </Layout>
  );
};

export default UploadPage;
